// extracted by mini-css-extract-plugin
module.exports = {"box":"Box_box__44Im9","colorBlue":"Box_colorBlue__1MezG","colorRed":"Box_colorRed__2CJxY"};